import React from 'react'

import { LntButton, LntDrawer, LntForm, LntFormItem, LntInput, LntTextArea } from '@app/components/base'
import { FILTERS_PLACEHOLDERS } from '@app/constants/filters'

import { BUTTON_TYPE, SIZE } from '@app/constants'

import { CommonContractorDrawerProps } from './types'

import styles from './styles.module.scss'

import type { LntInputProps } from '@app/components/base/Form/Input/types'
import type { LntTextAreaProps } from '@app/components/base/Form/Input/TextArea/types'
import type { CommonContractorsData } from '@app/api/routes/contractors/types'

const commonInputProps: LntInputProps = { size: SIZE.large }
const textAreaProps: LntTextAreaProps = { size: SIZE.large }

export const CommonContractorDrawer: React.FC<CommonContractorDrawerProps> = props => {
  const { data, onClose, onSubmit, ...restProps } = props

  const handleSubmit = (data: CommonContractorsData): void => onSubmit(data)

  return (
    <LntDrawer
      { ...restProps }
      onClose={ onClose }
      width={ 400 }
    >
      <LntForm
        layout='vertical'
        onSubmit={ handleSubmit }
      >
        <div className={ styles.commonContractorDrawer__itemsWrapper }>
          <LntFormItem
            name='name'
            defaultValue={ data?.name }
            validationOptions={ { rules: { required: 'Введите имя' } } }
          >
            <LntInput
              { ...commonInputProps }
              placeholder={ FILTERS_PLACEHOLDERS.name }
            />
          </LntFormItem>

          <LntFormItem
            name='login'
            defaultValue={ data?.login }
          >
            <LntInput
              { ...commonInputProps }
              placeholder={ FILTERS_PLACEHOLDERS.login }
            />
          </LntFormItem>

          <LntFormItem
            name='email'
            defaultValue={ data?.email }
            validationOptions={ { rules: { required: 'Введите электронную почту' } } }
          >
            <LntInput
              { ...commonInputProps }
              placeholder={ FILTERS_PLACEHOLDERS.email }
              type='email'
            />
          </LntFormItem>

          <LntFormItem
            name='additionalInfo'
            defaultValue={ data?.additionalInfo }
          >
            <LntTextArea
              { ...textAreaProps }
              placeholder={ FILTERS_PLACEHOLDERS.additionalInfo }
            />
          </LntFormItem>

          <LntFormItem
            name='contacts'
            defaultValue={ data?.contacts }
            validationOptions={ { rules: { required: 'Введите контакты' } } }
          >
            <LntTextArea
              { ...textAreaProps }
              placeholder={ FILTERS_PLACEHOLDERS.contacts }
            />
          </LntFormItem>

          <div className={ styles.commonContractorDrawer__buttons }>
            <LntButton
              type={ BUTTON_TYPE.secondary }
              size={ SIZE.middle }
              onClick={ onClose }
            >
              Отменить
            </LntButton>
            <LntButton
              type={ BUTTON_TYPE.primary }
              size={ SIZE.middle }
              htmlType='submit'
            >
              Сохранить
            </LntButton>
          </div>
        </div>
      </LntForm>
    </LntDrawer>
  )
}
